import React from 'react';

import { Flex } from '@chakra-ui/react';

import { MeshAiRegularWithoutPadding } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const MeshMavenLoading = ({ loadingText, textProps = {}, ...props }) => (
  <Flex flexDir="column" alignItems="center" padding={6} {...props}>
    <MeshAiRegularWithoutPadding boxSize="52px" />
    <TextBodyMedium bold mt={4} mb={3} {...textProps}>
      {loadingText}
    </TextBodyMedium>
    <TextBodyMedium color="text.g2">Please wait...</TextBodyMedium>
  </Flex>
);

export default MeshMavenLoading;
